
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

/**
 * The upload container
 */
@Component({
    selector: 'nwpl-frnt-dossier-selector',
    templateUrl: './dossier-type.component.html',
    styleUrls: ['./dossier-type.component.scss']
})
export class DossierTypeComponent implements OnInit {

    /**
    * The is geometric change
    */
    @Input() isSpatialDossier: boolean;
    /**
     * The is regulations dossier
     */
    @Input() isRegulationsDossier: boolean;
    /**
     * The is validating
     */
    @Input() isValidating: boolean;
    /**
     * The is validated flag
     */
    @Input() isValidated: boolean;
    /**
     * The view type 'button' | 'checkbox';
     */
    @Input() viewType: 'button' | 'checkbox' = 'button';
    /**
     * Is geometric changed event
     */
    @Output() geometricChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    /**
     * Is norme changed event
     */
    @Output() normeChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    /**
     * Construct the dossier type selector component
     * @param logger the logger
     */
    constructor() {

    }

    /**
     * The ng onInit hook
     */
    ngOnInit(): void {

    }

    /**
     * Select geometric change
     */
    selectGeometric($event: Event) {
        const checkbox = $event.target as HTMLInputElement;
        this.geometricChanged.emit(checkbox.checked);
    }

    /**
     * Select norme change
     */
    selectNorme($event) {
        const checkbox = $event.target as HTMLInputElement;
        this.normeChanged.emit(checkbox.checked);
    }
}